import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const UploadKit = () => {
  const nav = useNavigate();
  const [f, setF] = useState({ destination: "", title: "", subtitle: "" });
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/relocation/kits", f);
      toast.success("Kit created — now upload its files");
      nav(`/relocation/${data.id}?tab=files`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button data-testid="reloc-upload-kit" variant="outline" className="rounded-none h-12 px-6 border-[#3B1B48] text-[#3B1B48]"><UploadCloud className="w-4 h-4 mr-2" />Upload a kit</Button>
      </DialogTrigger>
      <DialogContent className="rounded-none bg-[#FAF7F2] max-w-lg" data-testid="reloc-upload-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#3B1B48]">Upload your own relocation kit</DialogTitle>
          <DialogDescription>Create the guide, then add its PDFs, cover and mobile app on the next screen. It stays a draft until you publish it.</DialogDescription>
        </DialogHeader>
        <Input data-testid="kit-destination" value={f.destination} onChange={(e) => setF({ ...f, destination: e.target.value })} placeholder="Country (moving from Australia to…)" className="rounded-none bg-white h-11" />
        <Input data-testid="kit-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Title, e.g. From Down Under to Aotearoa (optional)" className="rounded-none bg-white h-11" />
        <Input data-testid="kit-subtitle" value={f.subtitle} onChange={(e) => setF({ ...f, subtitle: e.target.value })} placeholder="Subtitle (optional)" className="rounded-none bg-white h-11" />
        <Button data-testid="kit-create" onClick={go} disabled={busy || f.destination.trim().length < 2} className="rounded-none h-11">{busy ? "Creating…" : "Create kit and add files"}</Button>
      </DialogContent>
    </Dialog>
  );
};
